<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2023-08-30 16:51:57
 * @LastEditors: 
 * @LastEditTime: 2023-11-16 10:28:53
-->
<template>
  <div style="padding-top: 1px">
    <flashSale
      title="限时抢购"
      fromCom="timeLimit"
      :hideTitle="true"
      v-if="flashSaleList.length > 0"
      :dataList="flashSaleList"
    ></flashSale>
    <van-empty v-else description="暂无商品信息,敬请期待" />
  </div>
</template>

<script>
import flashSale from "@/newViews/homePage/comps/flashSale.vue";
import { getGroupGoodsList } from "@/api/activity";
import { mapState } from "vuex";
export default {
  name: "AllFlashSaleList",
  props: {},

  components: {
    flashSale,
  },
  data() {
    return {
      flashSaleList: [],
    };
  },

  computed: {
    ...mapState({
      vpnId: (rootState) => rootState.vpnId,
    }),
  },
  created() {},
  mounted() {
    this.handleGetLimitGoods();
  },
  updated() {},
  methods: {
    handleGetLimitGoods() {
      let params = {
        query: {
          // vpnId: '299792465',
          VpnId: this.vpnId,
          EventTypeId: 3,
          // type: this.activeTabName,
        },
        pager: {
          pageindex: 0,
          pagesize: 500,
        },
      };
      getGroupGoodsList(params)
        .then((res) => {
          let data = res.Items;
          this.flashSaleList = data;
        })
        .catch((err) => {});
    },
    // handleGetGroupBuyGoods() {
    //   const res = [
    //     {
    //       GoodsName: "拼团套餐",
    //       Price: 99,
    //       GoodsDetailExplain: "这是一个拼团套餐",
    //       Number: 10,
    //       OriginPrice: 139,
    //       StatusMsg: null,
    //       SurplusNum: 10,
    //       endTime: "2022-07-20T17:05:56",
    //     },
    //   ];
    //   res.forEach((item) => {
    //     let timeNum = new Date(item.endTime) - new Date();
    //     console.log(new Date(item.endTime));
    //     console.log("================" + timeNum);
    //     item.time = timeNum;
    //   });
    //   this.groupBuyList = res;
    // },
  },
};
</script>
<style scoped lang="scss"></style>
